<template>
  <TopGradientBlockLayout class="flex flex-col">
    <template v-slot:top>
      <AccountsSettingsForm :full-settings="false"/>
    </template>
    <AccountsList :space_sort="current_space.data.account_sort_type"
                  :key="acc_groups_key"
                  class="mb-13 lg:mb-27"
                  @edit="openEditAccountModal"
                  @editGroup="openEditGroupModal"/>
    <div class="border-t border-border -mx-12 mt-auto p-12 pb-0">
      <ButtonGrouped @click="$emit('nextStep')">
        <template v-slot:left>{{$t('finishText')}}</template>
        <template v-slot:right>
          <IconArrow direction="right" class="mr-2 w-4-5 h-4-5"/>
          {{$t('nextStep')}}
        </template>
      </ButtonGrouped>
    </div>
    <transition name="modal">
      <AccountsSettingsEditModal v-if="!!edit_account_item"
                                 :edit_item="edit_account_item"
                                 @close="edit_account_item = null"/>
    </transition>
    <transition name="modal">
      <AccountGroupEditModal v-if="!!group_edit_item"
                             :group="group_edit_item"
                             @close="group_edit_item=null"
                             @onRemove="updateAccounts"
                             @onUpdate="updateAccounts"/>
    </transition>
  </TopGradientBlockLayout>
</template>

<script>
import TopGradientBlockLayout from "@/components/layouts/cabinet/TopGradientBlockLayout";
import AccountsSpaceSettings from "@/components/cabinet/SpaceSettings/AccountsSpaceSettings/AccountsSpaceSettings";
import AccountsSettingsForm from "@/components/cabinet/SpaceSettings/AccountsSettings/AccountsSettingsForm";
import AccountsList from "@/components/cabinet/SpaceSettings/AccountsSettings/AccountsList";
import {mapState} from "vuex";
import AccountsSettingsEditModal from "@/components/cabinet/SpaceSettings/AccountsSettings/AccountsSettingsEditModal";
import AccountGroupEditModal from "@/components/cabinet/SpaceSettings/AccountsSettings/AccountGroupEditModal";
import ButtonGrouped from "@/components/UI/ButtonGrouped";
import IconArrow from "@/components/icons/IconArrow";

export default {
  name: "WizardStep1",
  components: {
    IconArrow,
    ButtonGrouped,
    AccountGroupEditModal,
    AccountsSettingsEditModal,
    AccountsSettingsForm,
    AccountsList,
    AccountsSpaceSettings,

    TopGradientBlockLayout
  },
  data() {
    return {
      dataFetched: false,
      edit_account_item: null,
      group_edit_item: null,
      acc_groups_key: 0,
    }
  },
  computed: {
    ...mapState('space', ['current_space']),
    ...mapState('space/accounts', ['accounts', 'account_groups']),
  },
  watch: {
    'accounts.data': {
      immediate: true,
      handler: function (newVal) {
        if (!!newVal) {
          this.acc_groups_key++;
        }
      }
    }
  },
  methods: {
    openEditAccountModal(account) {
      this.edit_account_item = account;
    },
    openEditGroupModal(group) {
      this.group_edit_item = group;
    },
    async updateAccounts() {
      await this.$store.dispatch('space/accounts/getAccounts');
      await this.$store.dispatch('space/accounts/getAccountGroups');
    },
    async fetchMainData() {
      try {
        if (this.$store.state.space.accounts.accounts.data.length === 0) {
          await this.$store.dispatch('space/accounts/getAccounts');
          await this.$store.dispatch('space/accounts/getAccountGroups');
        }
      } catch (e) {
        throw e;
      }
    }
  },
  async created() {
    await this.fetchMainData()
    this.dataFetched = true;
  },
  i18n: {
    messages: {
      en: {
        finishText: 'I added all accounts',
        nextStep: 'Step 2'
      },
      ru: {
        finishText: 'Я добавил все счета',
        nextStep: 'Шаг 2'
      }
    }
  }
}
</script>